import { MessageCircle, Sparkles } from 'lucide-react';
import { Button } from '@city-sage/aurum-avis-labs-components';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useGlobalChat } from './ChatProvider';

export function ChatButton() {
  const { t } = useTranslation();
  const { open } = useGlobalChat();

  return (
    <>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        transition={{ 
          type: "spring", 
          stiffness: 300, 
          damping: 30 
        }}
        className="fixed bottom-12 right-6 z-50"
      >
        <Button
          onClick={open}
          className="h-14 w-14 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 shadow-lg hover:shadow-xl transition-all duration-200 border-0 p-0 flex items-center justify-center group"
          aria-label={t('common.chat.openChat')}
        >
          <div className="relative">
            <MessageCircle className="h-6 w-6 text-white group-hover:scale-110 transition-transform duration-200" />
            <div className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center">
              <Sparkles className="h-2 w-2 text-white" />
            </div>
          </div>
        </Button>
      </motion.div>

    </>
  );
} 